import React from 'react';

function AboutOCTests() {
  return (
    <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
      <div className="card" style={{ textAlign: 'center', padding: '60px 24px', marginBottom: '30px' }}>
        <h1 style={{ fontSize: '48px', marginBottom: '20px', color: '#10b981' }}>
          What is the Opportunity Class (OC) Test?
        </h1>
        <p style={{ fontSize: '20px', color: '#666', maxWidth: '800px', margin: '0 auto' }}>
          Everything you need to know about NSW Opportunity Class placement exams
        </p>
      </div>

      <div className="card" style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '32px', marginBottom: '20px', color: '#10b981' }}>Overview</h2>
        <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#666', marginBottom: '20px' }}>
          The Opportunity Class Placement Test is a computer-based examination for Year 4 students in 
          New South Wales who wish to gain entry into an Opportunity Class (OC) for Years 5 and 6. 
          These classes are designed for academically gifted students and provide an enriched learning 
          environment within regular primary schools.
        </p>
        <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#666' }}>
          The test is held at external test centres where computers are provided. All questions are 
          multiple-choice and answered using the computer. Each of the 3 test sections is equally 
          weighted at 33.3%.
        </p>
      </div>

      <div className="card" style={{ marginBottom: '30px', background: '#ecfdf5' }}>
        <h2 style={{ fontSize: '28px', marginBottom: '20px', color: '#10b981' }}>Test Components</h2>
        <div style={{ display: 'grid', gap: '20px' }}>
          <div style={{ padding: '20px', background: 'white', borderRadius: '8px', borderLeft: '4px solid #10b981' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', flexWrap: 'wrap', gap: '10px' }}>
              <h3 style={{ fontSize: '22px', marginBottom: '10px', color: '#10b981' }}>📖 Reading</h3>
              <div style={{ display: 'flex', gap: '10px' }}>
                <span style={{ background: '#ecfdf5', padding: '4px 10px', borderRadius: '6px', fontSize: '13px', color: '#065f46', fontWeight: '600' }}>14 questions</span>
                <span style={{ background: '#ecfdf5', padding: '4px 10px', borderRadius: '6px', fontSize: '13px', color: '#065f46', fontWeight: '600' }}>40 mins</span>
                <span style={{ background: '#ecfdf5', padding: '4px 10px', borderRadius: '6px', fontSize: '13px', color: '#065f46', fontWeight: '600' }}>33.3%</span>
              </div>
            </div>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Assesses various reading skills through a diverse range of texts including non-fiction, fiction, 
              poetry, magazine articles, and reports. 3 questions have multiple parts to answer.
            </p>
          </div>
          <div style={{ padding: '20px', background: 'white', borderRadius: '8px', borderLeft: '4px solid #4f46e5' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', flexWrap: 'wrap', gap: '10px' }}>
              <h3 style={{ fontSize: '22px', marginBottom: '10px', color: '#4f46e5' }}>🔢 Mathematical Reasoning</h3>
              <div style={{ display: 'flex', gap: '10px' }}>
                <span style={{ background: '#eef2ff', padding: '4px 10px', borderRadius: '6px', fontSize: '13px', color: '#3730a3', fontWeight: '600' }}>35 questions</span>
                <span style={{ background: '#eef2ff', padding: '4px 10px', borderRadius: '6px', fontSize: '13px', color: '#3730a3', fontWeight: '600' }}>40 mins</span>
                <span style={{ background: '#eef2ff', padding: '4px 10px', borderRadius: '6px', fontSize: '13px', color: '#3730a3', fontWeight: '600' }}>33.3%</span>
              </div>
            </div>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Assesses the student's ability to use mathematical understanding and knowledge to solve 
              problems from a range of maths topics. Calculators are not permitted.
            </p>
          </div>
          <div style={{ padding: '20px', background: 'white', borderRadius: '8px', borderLeft: '4px solid #f59e0b' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', flexWrap: 'wrap', gap: '10px' }}>
              <h3 style={{ fontSize: '22px', marginBottom: '10px', color: '#f59e0b' }}>🧠 Thinking Skills</h3>
              <div style={{ display: 'flex', gap: '10px' }}>
                <span style={{ background: '#fef3c7', padding: '4px 10px', borderRadius: '6px', fontSize: '13px', color: '#92400e', fontWeight: '600' }}>30 questions</span>
                <span style={{ background: '#fef3c7', padding: '4px 10px', borderRadius: '6px', fontSize: '13px', color: '#92400e', fontWeight: '600' }}>30 mins</span>
                <span style={{ background: '#fef3c7', padding: '4px 10px', borderRadius: '6px', fontSize: '13px', color: '#92400e', fontWeight: '600' }}>33.3%</span>
              </div>
            </div>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Evaluates critical thinking and problem-solving abilities through various question types. 
              No previous knowledge is required for this test.
            </p>
          </div>
        </div>
      </div>

      <div className="card" style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '28px', marginBottom: '20px', color: '#10b981' }}>Key Differences: OC vs Selective</h2>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '16px' }}>
            <thead>
              <tr style={{ background: '#f9fafb' }}>
                <th style={{ padding: '14px 16px', textAlign: 'left', borderBottom: '2px solid #e5e7eb', color: '#374151' }}></th>
                <th style={{ padding: '14px 16px', textAlign: 'center', borderBottom: '2px solid #e5e7eb', color: '#10b981' }}>OC Placement</th>
                <th style={{ padding: '14px 16px', textAlign: 'center', borderBottom: '2px solid #e5e7eb', color: '#4f46e5' }}>Selective</th>
              </tr>
            </thead>
            <tbody>
              <tr><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', fontWeight: '600' }}>For Students In</td><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', textAlign: 'center' }}>Year 4</td><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', textAlign: 'center' }}>Year 6</td></tr>
              <tr style={{ background: '#f9fafb' }}><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', fontWeight: '600' }}>Entry Into</td><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', textAlign: 'center' }}>Year 5/6 OC</td><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', textAlign: 'center' }}>Year 7 Selective HS</td></tr>
              <tr><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', fontWeight: '600' }}>Subjects</td><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', textAlign: 'center' }}>3 (no Writing)</td><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', textAlign: 'center' }}>4 (incl. Writing)</td></tr>
              <tr style={{ background: '#f9fafb' }}><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', fontWeight: '600' }}>Test Format</td><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', textAlign: 'center' }}>Computer-based</td><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', textAlign: 'center' }}>Computer-based</td></tr>
              <tr><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', fontWeight: '600' }}>Total Time</td><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', textAlign: 'center' }}>~110 mins</td><td style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', textAlign: 'center' }}>~170 mins</td></tr>
              <tr style={{ background: '#f9fafb' }}><td style={{ padding: '12px 16px', fontWeight: '600' }}>Held In</td><td style={{ padding: '12px 16px', textAlign: 'center' }}>May each year</td><td style={{ padding: '12px 16px', textAlign: 'center' }}>May each year</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="card" style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '28px', marginBottom: '20px', color: '#10b981' }}>Important Information</h2>
        <ul style={{ fontSize: '18px', lineHeight: '2', color: '#666', paddingLeft: '20px' }}>
          <li>The test is typically held in May each year</li>
          <li>Students must be in Year 4 to sit for the test</li>
          <li>Results are used for Year 5 placement in an Opportunity Class</li>
          <li>OC classes are available in selected primary schools across NSW</li>
          <li>All questions are multiple-choice, answered on a computer</li>
          <li>There is no Writing component in the OC test</li>
          <li>Practice and preparation can significantly improve performance</li>
        </ul>
      </div>

      <div className="card" style={{ marginBottom: '30px', background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', color: 'white' }}>
        <h2 style={{ fontSize: '28px', marginBottom: '20px' }}>Official NSW Education Resources</h2>
        <p style={{ fontSize: '16px', marginBottom: '20px', opacity: '0.9' }}>
          For official information and resources, visit these NSW Department of Education pages:
        </p>
        <div style={{ display: 'grid', gap: '15px' }}>
          <a 
            href="https://education.nsw.gov.au/public-schools/selective-high-schools-and-opportunity-classes/year-5"
            target="_blank" rel="noopener noreferrer"
            style={{ display: 'block', padding: '15px 20px', background: 'rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', textDecoration: 'none', transition: 'all 0.3s' }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
          >
            <strong>Opportunity Classes - Year 5</strong><br />
            <span style={{ fontSize: '14px', opacity: '0.9' }}>Official information about opportunity classes</span>
          </a>
          <a 
            href="https://education.nsw.gov.au/public-schools/selective-high-schools-and-opportunity-classes/year-5/the-test"
            target="_blank" rel="noopener noreferrer"
            style={{ display: 'block', padding: '15px 20px', background: 'rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', textDecoration: 'none', transition: 'all 0.3s' }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
          >
            <strong>About The OC Test</strong><br />
            <span style={{ fontSize: '14px', opacity: '0.9' }}>Details about test format and content</span>
          </a>
        </div>
      </div>

      <div className="card" style={{ textAlign: 'center', padding: '40px 24px' }}>
        <h2 style={{ fontSize: '28px', marginBottom: '20px', color: '#10b981' }}>Ready to Start Practicing?</h2>
        <p style={{ fontSize: '16px', color: '#666', marginBottom: '30px' }}>
          Use our free practice tests to prepare for the OC placement exam
        </p>
        <a href="/exams" style={{ textDecoration: 'none' }}>
          <button className="btn-primary" style={{ fontSize: '18px', padding: '16px 32px' }}>
            Start Practice Tests
          </button>
        </a>
      </div>
    </div>
  );
}

export default AboutOCTests;
